"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DepositFailed_1 = __importDefault(require("./DepositFailed"));
exports.default = DepositFailed_1.default;
